import React, { useEffect, useState } from 'react';
import GenerateQrCode from '../../components/QRCodeGenerator';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../constants/api';

const QrCodeProfile = () => {
  const currentUrl = window.location.href; // get current URL

  const { route, id } = useParams();
  const [company, setCompany] = useState();
  const [profile, setProfile] = useState();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/users/get-company/user-login`
        );

        console.log(response.data.company);
        setCompany(response.data.company[0]);
        const company = response.data.company[0];

        if (company?.name) {
          document.title = company.name;
        }

        // Set Favicon
        if (company?.logo) {
          const favicon = document.querySelector("link[rel='icon']");
          if (favicon) {
            favicon.href = company.logo; // Update favicon dynamically
          }
        }
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        // setError('Company not found');
      }
    };

    const fetchInvoice = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/sys/invoice/${route}/${id}`
        );

        console.log(response.data);
        setProfile(response.data);
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        // setError('Company not found');
      }
    };

    fetchCompany();

    fetchInvoice();
    //window.print();
  }, []);

  console.log('profile:', profile);
  return (
    <div className="card mx-auto my-4" style={{ maxWidth: '500px' }}>
      {/* Company Logo & Name */}
      <div className="card-header text-center">
        <img
          src={`${API_URL}/${company?.logo}`}
          alt={company?.name}
          style={{ height: '50px', objectFit: 'contain' }}
          className="mb-2"
        />
        <h5 className="card-title mb-0">{company?.name}</h5>
      </div>

      {/* Profile Image */}
      <div className="card-body text-center">
        <img
          src={`${API_URL}/${profile?.image}`}
          alt={profile?.name}
          className="rounded-circle mb-3"
          style={{ width: '100px', height: '100px', objectFit: 'cover' }}
        />

        {/* Dynamic Profile Info */}
        <ul className="list-group list-group-flush text-start">
          {profile &&
            Object.entries(profile).map(([key, value]) => {
              if (key === 'image') return null; // Skip image key
              return (
                <li key={key} className="list-group-item">
                  <strong className="text-capitalize">{key}:</strong> {value}
                </li>
              );
            })}
        </ul>
      </div>

      <hr />
      <center>
        <GenerateQrCode url={currentUrl} />
        <p>Scan to verify</p>
      </center>
    </div>
  );
};

export default QrCodeProfile;
